export default (state, action) => {
  return Object.assign({}, state, {
    ...state,
    cookies: action.payload,
  });
};
